import { z } from 'zod';
import { DeliveryArticleCategoryModelSchema } from 'entities/delivery-article-category';
import { GetDeliveryArticleCategoriesApiResponseSchema } from '../store';

export const createDeliveryArticleCategoriesFromGetDeliveryArticleCategoriesApiResponse = (
    (response: z.infer< typeof GetDeliveryArticleCategoriesApiResponseSchema>) => (
        response.data.map(({
            slug,
            name,

        }) => DeliveryArticleCategoryModelSchema.parse({
            uid: slug,
            name,
        }))
    )
);
